export default __webpack_public_path__ + "static/media/teacher.6cb905b8.png";